import {Component, OnInit} from '@angular/core';
import {LoginRequestService} from '../../../shared/service/login-request.service';
import {TranslateContext} from '@shared/pipes/translate.pipe';

@Component({
	selector: 'amd-logout-dialog',
	templateUrl: './logout-dialog.component.html',
	styleUrls: ['./logout-dialog.component.scss']
})
export class LogoutDialogComponent implements OnInit {

	translateContext: TranslateContext = TranslateContext.CORE;

	constructor() {
	}

	ngOnInit() {
	}

	onClick(event: any) {
		LoginRequestService.logout();
	}
}
